var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4011 55.7143C25.96 57.9429 26.8605 60.0167 28.0716 61.9048H6.21053C2.76368 61.9048 0 59.15 0 55.7143V6.19048C0 2.78571 2.76368 0 6.21053 0H43.4737C46.9205 0 49.6842 2.78571 49.6842 6.19048V31.5095C48.1316 31.1691 46.5789 30.9524 45.0263 30.9524C44.4984 30.9524 44.0016 30.9524 43.4737 31.0452V6.19048H27.9474V30.9524L20.1842 23.9881L12.4211 30.9524V6.19048H6.21053V55.7143H25.4011ZM59 51.0714C59 58.8095 52.7895 65 45.0263 65C37.2632 65 31.0526 58.8095 31.0526 51.0714C31.0526 43.3333 37.2632 37.1429 45.0263 37.1429C52.7895 37.1429 59 43.3333 59 51.0714ZM49.6842 59.0571L37.0147 46.4286C36.1763 47.7286 35.7105 49.3381 35.7105 51.0714C35.7105 56.2095 39.8716 60.3571 45.0263 60.3571C46.7653 60.3571 48.38 59.8929 49.6842 59.0571ZM54.3421 51.0714C54.3421 45.9333 50.1811 41.7857 45.0263 41.7857C43.2874 41.7857 41.6726 42.25 40.3684 43.0857L53.0379 55.7143C53.8763 54.4143 54.3421 52.8048 54.3421 51.0714Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ba9a6aeb8caa373ff6abc40d97fecd9a.svg";
export { ForwardRef as ReactComponent };